import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import loansDetailComponent from './loansDetail.component';
import loansDetailHeader from './loansDetailHeader/loansDetailHeader';
import loansDetailCollapse from './loansDetailCollapse/loansDetailCollapse';
import loansDetailPurposes from './loansDetailPurposes/loansDetailPurposes';
import loansDetailBasicCharacteristics from './loansDetailBasicCharacteristics/loansDetailBasicCharacteristics';
import loansDetailMinimumFee from './loansDetailMinimumFee/loansDetailMinimumFee';
import loansDetailRequestIt from './loansDetailRequestIt/loansDetailRequestIt';
import loansDetailPrepayments from './loansDetailPrepayments/loansDetailPrepayments';
import loansDetailSendDocumentation from './loansDetailSendDocumentation/loansDetailSendDocumentation';
import loansDetailFinishDeadline from './loansDetailFinishDeadline/loansDetailFinishDeadline';
import loansDetailStatementIncome from './loansDetailStatementIncome/loansDetailStatementIncome';
import loansDetailNewCreditCapacity from './loansDetailNewCreditCapacity/loansDetailNewCreditCapacity';

let loansDetailModule = angular.module('loansDetail', [
  uiRouter,
  loansDetailHeader,
  loansDetailCollapse,
  loansDetailPurposes,
  loansDetailBasicCharacteristics,
  loansDetailMinimumFee,
  loansDetailRequestIt,
  loansDetailPrepayments,
  loansDetailSendDocumentation,
  loansDetailFinishDeadline,
  loansDetailStatementIncome,
  loansDetailNewCreditCapacity,
])

  .component('loansDetail', loansDetailComponent)

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.LOANS.DETAIL, {
        url: ROUTES.LOANS.DETAIL,
        component: 'loansDetail',
        params: {
          allowGoBack: false,
          from: null,
          originalFrom: null,
          snapshot: null,
        },
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          serviceClosed: (StatusAppCheckers) => StatusAppCheckers.isServiceClosed(),
        },
      });
  })

  .name;

export default loansDetailModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetail.js